export default {
  getAdminAccountByName: state => inputValue => {
    return state.adminAccounts.filter(adminAccount => {
      var result = adminAccount.adminUserName
      return result.match(inputValue)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adminAccountModules/getters.js